import { IFramePlayerEventVO } from 'iframe/ts/player/events/IFramePlayerEventVO';
import { IFramePlayerEventDataVO } from 'iframe/ts/player/events/IIFramePlayerEventDataVO';
import { LogService } from 'library/ts/utilities/logger/LogService';
export class IFramePlayerAbstractClass {
    #name;
    #logger;
    #iframePlayer;
    constructor(iframePlayer, name = 'IFramePlayerAbstractClass') {
        this.#iframePlayer = iframePlayer;
        this.#name = name;
        this.#logger = LogService.create({ prefixes: ['IFramePlayer:', this.#name] });
    }
    get name() {
        return this.#name;
    }
    get iframePlayer() {
        return this.#iframePlayer;
    }
    get logger() {
        return this.#logger;
    }
    get utils() {
        return window?.IFramePlayer?.utilities;
    }
    get capabilities() {
        return window?.IFramePlayer?.capabilities;
    }
    get runtimeVO() {
        return window?.IFramePlayer?.runtimeVO;
    }
    get scripted() {
        return this?.iframePlayer?.scripted;
    }
    getIFramePlayerEventDataVO = () => {
        return new IFramePlayerEventDataVO();
    };
    getIFramePlayerEventVO = (eventVO) => {
        return new IFramePlayerEventVO(eventVO.type, eventVO.iframePlayer, eventVO.data, eventVO.error, eventVO.target, eventVO.targetName, eventVO.sendPostMessage);
    };
    dispatchIFramePlayerEvent = (eventVO, delay = undefined) => {
        const timeNow = new Date().getTime();
        eventVO.uuid = this?.runtimeVO?.uuid;
        if (this.utils.Type.isNumber(window?.IFramePlayer?.startTime)) {
            eventVO.msFromStart = timeNow - window?.IFramePlayer?.startTime;
            eventVO.timeFromStart = this.utils.Date.secondsToHHMMSSMS(eventVO.msFromStart / 1000);
        }
        this.utils.Delay.delay(delay)
            .then(() => {
            if (eventVO?.sendPostMessage !== false) {
                this.iframePlayer.postMessageHub.postMessage({
                    iframeEvent: {
                        type: eventVO?.type,
                        uuid: this?.runtimeVO?.uuid,
                        data: eventVO?.data,
                        targetName: eventVO?.targetName,
                        msFromStart: eventVO?.msFromStart,
                        timeFromStart: eventVO?.timeFromStart
                    }
                });
            }
        })
            .then(() => this.utils.Delay.delay(delay))
            .then(() => {
            this.iframePlayer.eventDispatcher.dispatchEvent(eventVO);
        });
    };
    appEventsHandler = (callback, events, subscriber = this) => {
        if (this.utils.Type.isDefined(callback) && this.utils.Type.isDefined(events)) {
            if (this.utils.Type.isArray(events) && !this.utils.Type.isEmpty(this?.iframePlayer?.eventDispatcher)) {
                for (let i = 0; i < events.length; i++) {
                    this.iframePlayer.eventDispatcher.addEventListener(events[i], callback, subscriber);
                }
            }
        }
    };
}
